// extracted by mini-css-extract-plugin
export var borderRadius = "_4r-4";
export var large = "_4r-3";
export var logoContainer = "_4r-0";
export var nameLogo = "_4r-2";
export var small = "_4r-1";